import {
  appbarHeightMobile,
  footerHeightMobile,
  appbarHeight,
  footerHeight,
  padding,
  layoutHeightCards2,
  layoutHeightCards2XS,
  layoutHeightCards4,
  layoutHeightCards4XS,
  layoutHeightCards6,
  layoutHeightCards6XS,
  maxWidthCard,
  maxWidthCardXS,
  stikyContent,
} from "themes/constants/sizes"
import {
  masterBreakPoint,
  largeWidthBreakPoint,
  maxWidth500,
} from "./breakpoints"
import { palette } from "./palette"

/**
 * Creates all flex rules
 * @param {String} flexFlow
 * @param {String} justifyContent
 * @param {String} alignItems
 */
const flexy = (flexFlow, justifyContent, alignItems) => ({
  display: "flex",
  flexFlow,
  justifyContent,
  alignItems,
})

/**
 * Convert HEX color to rgb with opacity
 * convertToRGB('#cccccc', 0.5) | output => "rgba(204,204,204,0.5)"
 *
 * @param {String} HEXColor - starting with '#'
 * @param {Number} opacity
 */

const convertToRGB = (HEXColor, opacity = 1) => {
  let c
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(HEXColor)) {
    c = HEXColor.substring(1).split("")
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]]
    }
    c = `${"0x"}${c.join("")}`
    return `rgba(${[(c >> 16) & 255, (c >> 8) & 255, c & 255].join(
      ","
    )}, ${opacity})`
  }
  throw new Error("Bad HEXColor")
}

const toolbar = {
  borderBottom: 1,
  borderColor: "#EBEAED",
  minHeight: 60,
  [`${masterBreakPoint}`]: {
    minHeight: 40,
  },
}

const footer = {
  minHeight: 60,
  [`${masterBreakPoint}`]: {
    minHeight: 40,
  },
}

const activityCircle = {
  width: 36,
  height: 36,
  mb: 0.5,
  borderRadius: 20,
  [`${masterBreakPoint}`]: {
    width: 30,
    height: 30,
    borderRadius: 15,
  },
}

const activityPath = {
  maxWidth: 200,
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  fontSize: 14,
  [`${masterBreakPoint}`]: {
    maxWidth: 70,
  },
}

const layout = {
  // header size + footer size
  minHeight: `calc(100vh - calc(${appbarHeight}px + ${footerHeight}px))`,
  px: 1,
  [masterBreakPoint]: {
    minHeight: `calc(100vh - calc(${appbarHeightMobile}px + ${footerHeightMobile}px))`,
  },
}

const container = {
  paddingBottom: `${footerHeight}px`,
  [masterBreakPoint]: {
    paddingBottom: `${footerHeightMobile}px`,
  },
}

const mainLayout = {
  backgroundColor: palette.background.main,
  height: `calc(100vh - ${appbarHeight}px)`,
  overflow: "auto",
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#fa8a38",
    background: "#fa8a38",
  },
  // scrollbar hover
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: "#fa8a38",
    background: "#fa8a38",
  },
  // scrolbar unfocused
  "&::-webkit-scrollbar-thumb:window-inactive": {
    backgroundColor: "#fa8a38",
    background: "#fa8a38",
  },
}

const icon = {
  backgroundColor: "#fff",
  borderRadius: "50%",
  fontSize: {
    xs: 24,
    lgH: 30,
  },
  padding: 0.5,
  strokeWidth: 5,
}

const checkIcon = {
  ...icon,
  stroke: "#7DC242",
}

const wrongIcon = {
  ...icon,
  stroke: "#ED1C24",
}

const key = {
  fontSize: 20,
  [masterBreakPoint]: {
    fontSize: 16,
  },
}

const keys = {
  textTransform: "none",
}

const matchingBox2 = {
  padding: `.5rem ${padding}`,
  flex: 2,
  maxHeight: `${layoutHeightCards2()}`,
  [masterBreakPoint]: {
    maxHeight: `${layoutHeightCards2XS()}`,
    maxWidth: `calc(${layoutHeightCards2XS()} * 1.4)`,
  },
}

const matchingBox4 = {
  flex: "0 0 calc(100% / 2)",
  padding: `.5rem ${padding}`,
  maxHeight: `${layoutHeightCards4()}`,
  [masterBreakPoint]: {
    maxHeight: `${layoutHeightCards4XS()}`,
  },
  [maxWidth500]: {
    maxWidth: `calc(${layoutHeightCards4XS()} * 1.4)`,
  },
  [largeWidthBreakPoint]: {
    flex: 1,
    maxWidth: `33%`,
    maxHeight: `calc(100vh - ${
      appbarHeightMobile + footerHeightMobile + stikyContent
    }px)`,
  },
}

const matchingBox3 = {
  [largeWidthBreakPoint]: {
    maxWidth: `50%`,
  },
}

const matchingBox5 = {
  [largeWidthBreakPoint]: {
    maxWidth: `25%`,
  },
}

const matchingBox6 = {
  flex: "0 0 calc(100% / 3)",
  padding: `${padding}`,
  maxHeight: `${layoutHeightCards6()}`,
  minWidth: "200px",
  [masterBreakPoint]: {
    maxHeight: `${layoutHeightCards6XS()}`,
    maxWidth: `calc(${layoutHeightCards6XS()} * 1.4)`,
  },
  [largeWidthBreakPoint]: {
    flex: 1,
    maxWidth: `20%`,
    maxHeight: "100%",
  },
}

const matchingBox8 = {
  flex: "0 0 calc(100% / 4)",
  padding: `${padding}`,
  maxHeight: `${layoutHeightCards6()}`,
  minWidth: "200px",
  [masterBreakPoint]: {
    maxHeight: `${layoutHeightCards6XS()}`,
    maxWidth: `calc(${layoutHeightCards6XS()} * 1.4)`,
  },
  [largeWidthBreakPoint]: {
    flex: 1,
    maxWidth: `20%`,
    maxHeight: "100%",
  },
}

const matchingBoxs = {
  maxWidth: `${maxWidthCard()}`,
  [masterBreakPoint]: {
    maxWidth: `${maxWidthCardXS()}`,
  },
  [largeWidthBreakPoint]: {
    maxWidth: "100%",
  },
}

const matchingContainer = {
  alignItems: "center",
  paddingBottom: `${footerHeight - 8}px`,
  [masterBreakPoint]: {
    paddingBottom: `${footerHeightMobile - 8}px`,
  },
}

const textMax3Lines = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
}

const grammarDetails = {
  color: "white",
  textAlign: "center",
  width: "fit-content",
  px: 1,
  py: 0.1,
  [masterBreakPoint]: {
    "& .MuiAlert-message": {
      fontSize: 12,
    },
  },
}

const tabs = {
  minHeight: 0,
  mb: 1.5,
  "& .MuiTabs-indicator": {
    backgroundColor: "transparent",
  },
}

const tab = {
  textTransform: "none",
  backgroundColor: `rgba(255, 94, 0, 0.5)`,
  color: "#fff",
  "&.Mui-selected": {
    backgroundColor: palette.primary.main,
    color: "#fff",
  },
  minHeight: 0,
  minWidth: 0,
  px: 1.5,
  py: 1,
  [maxWidth500]: {
    px: 1,
  },
  // if first tab
  "&:first-child": {
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
  },
  // if last tab
  "&:last-child": {
    borderTopRightRadius: 8,
    borderBottomRightRadius: 8,
  },
}

const teacherNotes = {
  lineHeight: 1.42,
  height: "100%",
  outline: "none",
  overflowY: "auto",
  px: 2,
  py: 1.5,
  tabSize: 4,
  whiteSpace: "pre-wrap",
  wordWrap: "break-word",
  "& blockquote": {
    borderLeft: "4px solid #ccc",
    my: 0.5,
    pl: 2,
  },
}

const modalContent = {
  backgroundColor: `#fbfafc`, // palette.primary.main,
  padding: 3.5,
  borderRadius: 3,
  minHeight: 300,
  marginTop: 6,
  [maxWidth500]: {
    width: "95%",
  },
  [largeWidthBreakPoint]: {
    marginTop: 5,
  },
}

const switchButton = {
  height: 20,
  width: 52,
  p: 0,
  ml: "5px",
  overflow: "visible",
  "& .Mui-checked+.MuiSwitch-track": {
    backgroundColor: "#fde2d2",
    opacity: 1,
  },
  "& .Mui-checked .MuiSwitch-thumb": {
    color: palette.primary.main,
    border: "1px solid #fff",
  },
  "& .MuiSwitch-track": {
    backgroundColor: "#eee",
    opacity: 1,
    width: 36,
    height: 16,
  },
  "& .MuiSwitch-thumb": {
    color: "#b8b8b8",
    border: "1px solid #fff",
  },
  "& .MuiButtonBase-root": {
    p: 0,
    top: -2,
  },
}

export {
  flexy,
  convertToRGB,
  toolbar,
  footer,
  activityCircle,
  activityPath,
  layout,
  container,
  checkIcon,
  wrongIcon,
  matchingContainer,
  matchingBoxs,
  matchingBox2,
  matchingBox3,
  matchingBox4,
  matchingBox5,
  matchingBox6,
  matchingBox8,
  textMax3Lines,
  key,
  keys,
  grammarDetails,
  tabs,
  tab,
  teacherNotes,
  modalContent,
  mainLayout,
  switchButton,
}
